/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const DefaultCourseTierSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('DEFAULT_COURSE_TIER')],
    [
        'value',
        /* #__PURE__ */ parsers.maybeNull(
        /* #__PURE__ */ parsers.exactly('advanced', 'free', 'starter')),
    ],
]);
export class DefaultCourseTierSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return DefaultCourseTierSettingParser.decode(input).map(res => new DefaultCourseTierSetting(res));
    }
    static unsafeDecode(input) {
        return DefaultCourseTierSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return DefaultCourseTierSettingParser.encode(data);
    }
    static schema() {
        return DefaultCourseTierSettingParser.schema();
    }
}
